var ProductDataFactory = (function () {
    function ProductDataFactory() {
    }
    ProductDataFactory.fromProduct = function (product, list, position) {
        var _a, _b;
        return ({
            id: product.product_group_id,
            name: product.product_group,
            variant: product.product_name,
            category: product.category,
            brand: (_a = product.brand) !== null && _a !== void 0 ? _a : undefined,
            item_id: product.product_group_id,
            item_name: product.product_group,
            item_brand: (_b = product.brand) !== null && _b !== void 0 ? _b : undefined,
            item_category: product.category,
            item_variant: product.product_name,
            price: product.price,
            productId: product.product_id,
            imageUrl: product.authority_image_url,
            list: list,
            position: position,
        });
    };
    return ProductDataFactory;
}());
export default ProductDataFactory;
//# sourceMappingURL=ProductDataFactory.js.map